webpackJsonp([226801396857505],{

/***/ 168:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _en = __webpack_require__(286);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _layoutEn = __webpack_require__(168);
	
	var _layoutEn2 = _interopRequireDefault(_layoutEn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_en2.default, (0, _extends3.default)({}, props, _layoutEn2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(78), __esModule: true };

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(79), __esModule: true };

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(85);
	var $Object = __webpack_require__(11).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(86);
	var $Object = __webpack_require__(11).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(29);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(35), 'Object', { defineProperty: __webpack_require__(36).f });


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(37);
	var $getOwnPropertyDescriptor = __webpack_require__(83).f;
	
	__webpack_require__(118)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(94);
	var isArguments = __webpack_require__(93);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 93:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 94:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 100:
/***/ (function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ }),

/***/ 102:
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(100),
	    isArguments = __webpack_require__(101),
	    isArray = __webpack_require__(102);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ }),

/***/ 96:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(107);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(92);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(106);
	
	var _HelmetConstants = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(18);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(95));
	var shallowEqual = _interopDefault(__webpack_require__(108));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var fetchKeys = __webpack_require__(103);
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if (ret !== void 0) {
	        return !!ret;
	    }
	
	    if (objA === objB) {
	        return true;
	    }
	
	    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = fetchKeys(objA);
	    var keysB = fetchKeys(objB);
	
	    var len = keysA.length;
	    if (len !== keysB.length) {
	        return false;
	    }
	
	    compareContext = compareContext || null;
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < len; i++) {
	        var key = keysA[i];
	        if (!bHasOwnProperty(key)) {
	            return false;
	        }
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	        if (_ret === false || _ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	    }
	
	    return true;
	};

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _taggedTemplateLiteralLoose2 = __webpack_require__(3);
	
	var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
	
	var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(["\n  display: inline-block;\n  line-height: 0;\n  ", ";\n"], ["\n  display: inline-block;\n  line-height: 0;\n  ", ";\n"]),
	    _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(["\n\t\t", ";\n\t"], ["\n\t\t", ";\n\t"]);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var constants_1 = __webpack_require__(6);
	var getBreakpoint_1 = __webpack_require__(17);
	var Icon_1 = __webpack_require__(16);
	exports.ChannelList = function () {
	    return React.createElement(Wrapper, null, React.createElement(Item, { href: "https://facebook.com/steadio.hq/", target: "_blank", rel: "noopener" }, React.createElement(Icon_1.Icon, { icon: "facebook", size: 24 })), React.createElement(Item, { href: "https://twitter.com/SteadioHQ/", target: "_blank", rel: "noopener" }, React.createElement(Icon_1.Icon, { icon: "twitter", size: 24 })));
	};
	var Wrapper = styled_components_1.default.div(_templateObject, getBreakpoint_1.getBreakpoint(0)(_templateObject2, constants_1.SPACE.inline.s));
	var Item = styled_components_1.default.a(_templateObject, constants_1.SPACE.inline.xs);

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _taggedTemplateLiteralLoose2 = __webpack_require__(3);
	
	var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
	
	var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(["\n  border-top: 1px solid ", ";\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  ", ";\n"], ["\n  border-top: 1px solid ", ";\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  ", ";\n"]),
	    _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"]),
	    _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(["\n\t\talign-items: center;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t"], ["\n\t\talign-items: center;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t"]),
	    _templateObject4 = (0, _taggedTemplateLiteralLoose3.default)(["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  ", ";\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  ", ";\n"]);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var getBreakpoint_1 = __webpack_require__(17);
	var calcFontScale_1 = __webpack_require__(28);
	var constants_1 = __webpack_require__(6);
	var Container_1 = __webpack_require__(26);
	var ChannelList_1 = __webpack_require__(62);
	var react_intl_1 = __webpack_require__(12);
	var Select_1 = __webpack_require__(71);
	var Link_1 = __webpack_require__(27);
	var polished_1 = __webpack_require__(8);
	// @ts-ignore
	var theme = __webpack_require__(7);
	var messages = react_intl_1.defineMessages({
	    termsOfUse: {
	        id: 'footer.terms_of_use',
	        defaultMessage: 'Terms of Use'
	    },
	    privacyPolicy: {
	        id: 'footer.privacy_policy',
	        defaultMessage: 'Privacy Policy'
	    },
	    selectYourLanguage: {
	        id: 'footer.select_your_language',
	        defaultMessage: 'Select Your Language'
	    }
	});
	var FooterWrapped = function FooterWrapped(_ref) {
	    var intl = _ref.intl;
	    return React.createElement(Wrapper, null, React.createElement(Inner, null, React.createElement(Item, null, React.createElement(Select_1.Select, { title: intl.formatMessage(messages.selectYourLanguage), name: "lang", value: "en", options: [{ value: 'en', label: 'English' }, { value: 'ja', label: '日本語' }, { value: 'ko', label: '한국어' }], onChange: function onChange() {} })), React.createElement(Item, null, React.createElement("span", null, "Steadio by Tumblbug Inc. \xA9 2018", ' ', React.createElement(Link_1.Link, { to: "https://tumblbug.com/terms-of-use" }, intl.formatMessage(messages.termsOfUse)), ' ', "\xB7", ' ', React.createElement(Link_1.Link, { to: "https://tumblbug.com/privacy" }, intl.formatMessage(messages.privacyPolicy))), React.createElement(ChannelList_1.ChannelList, null))));
	};
	var colors = {
	    divider: theme('mode', {
	        light: function light(props) {
	            return polished_1.lighten(0.875, props.theme.color.black);
	        },
	        dark: function dark(props) {
	            return polished_1.lighten(0.125, props.theme.color.black);
	        }
	    })
	};
	var Wrapper = styled_components_1.default.footer(_templateObject, colors.divider, calcFontScale_1.calcFontScale(-1));
	var Inner = styled_components_1.default(Container_1.Container)(_templateObject2, constants_1.SPACE.inset.xs, getBreakpoint_1.getBreakpoint(0)(_templateObject3));
	var Item = styled_components_1.default.div(_templateObject4, constants_1.SPACE.inset.xs);
	exports.default = react_intl_1.injectIntl(FooterWrapped);

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _taggedTemplateLiteralLoose2 = __webpack_require__(3);
	
	var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
	
	var _templateObject = (0, _taggedTemplateLiteralLoose3.default)([""], [""]),
	    _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(["\n  align-items: center;\n  display: flex;\n  justify-content: ", ";\n  ", ";\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: ", ";\n  ", ";\n"]),
	    _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(["\n"], ["\n"]),
	    _templateObject4 = (0, _taggedTemplateLiteralLoose3.default)(["\n  ", ";\n"], ["\n  ", ";\n"]);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var Link_1 = __webpack_require__(27);
	var Container_1 = __webpack_require__(26);
	var Logotype_1 = __webpack_require__(66);
	var constants_1 = __webpack_require__(6);
	var calcFontScale_1 = __webpack_require__(28);
	var react_intl_1 = __webpack_require__(12);
	var themed_components_1 = __webpack_require__(54);
	var messages = react_intl_1.defineMessages({
	    signIn: {
	        id: 'header.sign_in',
	        defaultMessage: 'Sign in'
	    }
	});
	var HeaderWrapped = function HeaderWrapped(_ref) {
	    var isDumb = _ref.isDumb,
	        intl = _ref.intl;
	    return React.createElement(Wrapper, null, React.createElement(Inner, { isDumb: isDumb }, React.createElement(Link_1.Link, { to: "/" }, React.createElement(Logotype_1.Logotype, { width: 82.9, height: 23.7 })), !isDumb && React.createElement(SignInLink, { to: "/signin" }, intl.formatMessage(messages.signIn))));
	};
	var Wrapper = styled_components_1.default.div(_templateObject);
	var InnerWrapped = Container_1.Container.extend(_templateObject2, function (props) {
	    return props.isDumb ? 'center' : 'space-between';
	}, constants_1.SPACE.inset.s).withComponent('nav');
	var Inner = themed_components_1.withProps()(styled_components_1.default(InnerWrapped))(_templateObject3);
	var SignInLink = styled_components_1.default(Link_1.Link)(_templateObject4, calcFontScale_1.calcFontScale(-0.25));
	exports.default = react_intl_1.injectIntl(HeaderWrapped);

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.icons = {
	    facebook: 'M21,11.25A1.26,1.26,0,0,0,22.25,10V6A1.26,1.26,0,0,0,21,4.75H18A6.25,6.25,0,0,0,11.75,11v1.75H10A1.26,1.26,0,0,0,8.75,14v4A1.26,1.26,0,0,0,10,19.25h1.75V26A1.26,1.26,0,0,0,13,27.25h4A1.26,1.26,0,0,0,18.25,26V19.25H20a1.25,1.25,0,0,0,1.21-.95l1-4A1.24,1.24,0,0,0,22,13.23a1.28,1.28,0,0,0-1-.48H18.25v-1.5Zm-1.6,4L19,16.75H17A1.26,1.26,0,0,0,15.75,18v6.75h-1.5V18A1.26,1.26,0,0,0,13,16.75H11.25v-1.5H13A1.26,1.26,0,0,0,14.25,14V11A3.76,3.76,0,0,1,18,7.25h1.75v1.5H18A2.25,2.25,0,0,0,15.75,11v3A1.26,1.26,0,0,0,17,15.25Z',
	    twitter: 'M27.74,6.94a1.27,1.27,0,0,0-1.43,0A9.73,9.73,0,0,1,24.2,8.08a5.73,5.73,0,0,0-9.44,4.13A9.45,9.45,0,0,1,8,8.26a1.24,1.24,0,0,0-2.16.21,13.39,13.39,0,0,0-1,5,10.23,10.23,0,0,0,1.33,5.16A10.34,10.34,0,0,0,9.38,22a10.46,10.46,0,0,1-4,.78H5a1.25,1.25,0,0,0-.65,2.35,16.26,16.26,0,0,0,7.88,2.09,13.9,13.9,0,0,0,9.81-3.9,14.81,14.81,0,0,0,4.23-10.82h0c0-.14,0-.27,0-.41a9,9,0,0,0,2-3.8A1.25,1.25,0,0,0,27.74,6.94Zm-4,4.94a3.23,3.23,0,0,1,.06.61,12.28,12.28,0,0,1-3.48,9,11.37,11.37,0,0,1-8.06,3.19,12.75,12.75,0,0,1-2.37-.22,12.72,12.72,0,0,0,2.82-1.44,1.25,1.25,0,0,0-.2-2.18A8.65,8.65,0,0,1,8.32,17.4a7.62,7.62,0,0,1-1-3.89,10.25,10.25,0,0,1,.21-2,11.92,11.92,0,0,0,8.18,3.27H16a1.25,1.25,0,0,0,1.22-1.25V12.46A3.25,3.25,0,0,1,18.37,10a3.17,3.17,0,0,1,2.12-.8,3.23,3.23,0,0,1,2.45,1.12,1.24,1.24,0,0,0,1.16.39l0,0A1.23,1.23,0,0,0,23.72,11.88Z',
	    visible: 'M29.12,15.77c-.19-.38-4.81-9.41-13.12-9.41s-12.93,9-13.12,9.41a1.29,1.29,0,0,0,0,1.12c.19.39,4.81,9.42,13.12,9.42s12.93-9,13.12-9.42A1.29,1.29,0,0,0,29.12,15.77ZM16,23.81c-5.7,0-9.49-5.65-10.57-7.48C6.5,14.51,10.28,8.86,16,8.86s9.49,5.65,10.57,7.47C25.5,18.16,21.72,23.81,16,23.81Zm0-12a4.53,4.53,0,1,0,4.52,4.52A4.53,4.53,0,0,0,16,11.81Zm0,6.55a2,2,0,1,1,2-2A2,2,0,0,1,16,18.36Z',
	    invisible: 'M12.5,8.2c-0.2-0.7,0.3-1.3,0.9-1.5c0.8-0.2,1.7-0.3,2.6-0.3c8.3,0,12.9,9,13.1,9.4c0.2,0.4,0.2,0.8,0,1.1c-0.7,1.3-1.5,2.6-2.5,3.7c-0.2,0.3-0.6,0.4-1,0.4c-0.3,0-0.6-0.1-0.8-0.3c-0.5-0.4-0.6-1.2-0.2-1.8c0.7-0.8,1.3-1.7,1.9-2.7c-1.1-1.8-4.9-7.5-10.6-7.5c-0.7,0-1.4,0.1-2,0.2C13.3,9.2,12.6,8.8,12.5,8.2z M28.9,28.2c-0.2,0.2-0.6,0.4-0.9,0.4s-0.6-0.1-0.9-0.4L22.9,24c-2,1.4-4.4,2.2-6.9,2.3c-8.3,0-12.9-9-13.1-9.4c-0.2-0.4-0.2-0.8,0-1.2c1.3-2.5,3.1-4.6,5.3-6.4L4.1,5.2c-0.5-0.5-0.5-1.3,0-1.8s1.3-0.5,1.8,0l23,23C29.4,26.9,29.4,27.7,28.9,28.2z M13.9,16.5c0,0.5,0.2,1,0.6,1.4c0.4,0.4,0.9,0.6,1.4,0.5c0.4,0,0.7-0.1,1-0.3l-2.8-2.8C14,15.7,13.9,16.1,13.9,16.5z M21.1,22.2l-2.3-2.3c-0.8,0.6-1.7,1-2.7,1c-0.1,0-0.1,0-0.2,0c-1.1,0-2.2-0.4-3.1-1.2c-1.8-1.6-1.9-4.3-0.4-6.2L10,11.1c-1.8,1.5-3.4,3.2-4.6,5.2c1.1,1.8,4.9,7.5,10.6,7.5C17.8,23.8,19.6,23.2,21.1,22.2z',
	    cancel: 'M17.77,16l8.11-8.12a1.24,1.24,0,0,0-1.76-1.76L16,14.23,7.88,6.12A1.24,1.24,0,0,0,6.12,7.88L14.23,16,6.12,24.12a1.24,1.24,0,0,0,0,1.76,1.23,1.23,0,0,0,1.76,0L16,17.77l8.12,8.11a1.23,1.23,0,0,0,1.76,0,1.24,1.24,0,0,0,0-1.76Z',
	    caron: 'M25.25,13a1.21,1.21,0,0,1-.37.88l-8,8a1.24,1.24,0,0,1-1.76,0l-8-8a1.24,1.24,0,1,1,1.76-1.76L16,19.23l7.12-7.11a1.24,1.24,0,0,1,1.76,0A1.21,1.21,0,0,1,25.25,13Z',
	    verified: 'M16,27.65h0A11.73,11.73,0,0,1,16,4.2h0a11.67,11.67,0,0,1,4.77,1,1.25,1.25,0,0,1-1,2.29A9.16,9.16,0,0,0,16,6.7h0a9.23,9.23,0,0,0,0,18.45h0a9.23,9.23,0,0,0,9.22-9.22V15a1.25,1.25,0,1,1,2.5,0v1A11.74,11.74,0,0,1,16,27.65Zm.88-8.74L28.38,7.39a1.25,1.25,0,1,0-1.76-1.77L16,16.26,13.72,14A1.25,1.25,0,0,0,12,15.77l3.14,3.14a1.29,1.29,0,0,0,.89.37A1.25,1.25,0,0,0,16.86,18.91Z'
	};

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _taggedTemplateLiteralLoose2 = __webpack_require__(3);
	
	var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(["\n  fill: ", ";\n"], ["\n  fill: ", ";\n"]);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var icons_1 = __webpack_require__(32);
	var styled_components_1 = __webpack_require__(2);
	var polished_1 = __webpack_require__(8);
	// @ts-ignore
	var theme = __webpack_require__(7);
	exports.Icon = function (_ref) {
	    var icon = _ref.icon,
	        _ref$size = _ref.size,
	        size = _ref$size === undefined ? 30 : _ref$size,
	        props = (0, _objectWithoutProperties3.default)(_ref, ["icon", "size"]);
	    return React.createElement(Wrapper, (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: size, height: size }, props), React.createElement("path", { d: icons_1.icons[icon] }));
	};
	var colors = {
	    icon: theme('mode', {
	        light: function light(props) {
	            return polished_1.lighten(0.25, props.theme.color.black);
	        },
	        dark: function dark(props) {
	            return polished_1.lighten(0.5, props.theme.color.black);
	        }
	    })
	};
	var Wrapper = styled_components_1.default.svg(_templateObject, colors.icon);

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _taggedTemplateLiteralLoose2 = __webpack_require__(3);
	
	var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(["\n  color: ", ";\n  cursor: pointer;\n  font-weight: 500;\n  text-decoration: none;\n  ", ";\n"], ["\n  color: ", ";\n  cursor: pointer;\n  font-weight: 500;\n  text-decoration: none;\n  ", ";\n"]),
	    _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(["\n\t\tleft: 0;\n\t\tposition: relative;\n\t\ttransition: all 100ms ease-in-out 250ms;\n\t\t&:after {\n\t\t\tbackground-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M5,15.08H24.07L18.64,9.42a1.25,1.25,0,1,1,1.8-1.73l7.46,7.78a1.24,1.24,0,0,1,0,1.73L20.44,25a1.25,1.25,0,0,1-1.8-1.73l5.43-5.67H5a1.25,1.25,0,1,1,0-2.5Z\" fill=\"", "\"/></svg>');\n\t\t\tcontent: '';\n\t\t\tdisplay: block;\n\t\t\theight: 20px;\n\t\t\topacity: 1;\n\t\t\tposition: absolute;\n\t\t\tright: -25px;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t\ttransition: all 100ms ease-in-out 250ms;\n\t\t\twidth: 20px;\n\t\t}\n\t\t", "\n\t"], ["\n\t\tleft: 0;\n\t\tposition: relative;\n\t\ttransition: all 100ms ease-in-out 250ms;\n\t\t&:after {\n\t\t\tbackground-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M5,15.08H24.07L18.64,9.42a1.25,1.25,0,1,1,1.8-1.73l7.46,7.78a1.24,1.24,0,0,1,0,1.73L20.44,25a1.25,1.25,0,0,1-1.8-1.73l5.43-5.67H5a1.25,1.25,0,1,1,0-2.5Z\" fill=\"", "\"/></svg>');\n\t\t\tcontent: '';\n\t\t\tdisplay: block;\n\t\t\theight: 20px;\n\t\t\topacity: 1;\n\t\t\tposition: absolute;\n\t\t\tright: -25px;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t\ttransition: all 100ms ease-in-out 250ms;\n\t\t\twidth: 20px;\n\t\t}\n\t\t", "\n\t"]),
	    _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(["\n\t\t\t&:after {\n\t\t\t\topacity: 0;\n\t\t\t\tright: 0;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tleft: -10px;\n\t\t\t\ttransition: all 100ms ease-in-out 100ms;\n\t\t\t\t&:after {\n\t\t\t\t\topacity: 1;\n\t\t\t\t\tright: -25px;\n\t\t\t\t\ttransition: all 100ms ease-in-out 100ms;\n\t\t\t\t}\n\t\t\t} \n\t\t"], ["\n\t\t\t&:after {\n\t\t\t\topacity: 0;\n\t\t\t\tright: 0;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tleft: -10px;\n\t\t\t\ttransition: all 100ms ease-in-out 100ms;\n\t\t\t\t&:after {\n\t\t\t\t\topacity: 1;\n\t\t\t\t\tright: -25px;\n\t\t\t\t\ttransition: all 100ms ease-in-out 100ms;\n\t\t\t\t}\n\t\t\t} \n\t\t"]),
	    _templateObject4 = (0, _taggedTemplateLiteralLoose3.default)(["\n  ", ";\n"], ["\n  ", ";\n"]);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var gatsby_link_1 = __webpack_require__(98);
	var polished_1 = __webpack_require__(8);
	var getBreakpoint_1 = __webpack_require__(17);
	// @ts-ignore
	var theme = __webpack_require__(7);
	exports.Link = function (_ref) {
		var to = _ref.to,
		    _ref$variant = _ref.variant,
		    variant = _ref$variant === undefined ? "default" : _ref$variant,
		    props = (0, _objectWithoutProperties3.default)(_ref, ["to", "variant"]);
	
		// Any internal link(intended for Gatsby) is assumed to start with exactly one slash
		// and anything else is external.
		var internal = /^\/(?!\/)/.test(to);
		// Use gatsby-link for internal links, and <a> for others
		return internal ? React.createElement(GatsbyLinkWrapper, (0, _extends3.default)({ to: to, variant: variant }, props)) : React.createElement(Wrapper, (0, _extends3.default)({ href: to, target: "_blank", rel: "noopener", variant: variant }, props));
	};
	var colors = {
		link: theme.variants('mode', 'variant', {
			default: {
				light: function light(props) {
					return props.theme.color.black;
				},
				dark: function dark(props) {
					return polished_1.invert(props.theme.color.black);
				}
			},
			primary: {
				light: function light(props) {
					return props.theme.color.primary;
				},
				dark: function dark(props) {
					return props.theme.color.primary;
				}
			}
		})
	};
	var LINK_CSS = styled_components_1.css(_templateObject, colors.link, function (props) {
		return props.arrow && styled_components_1.css(_templateObject2, colors.link, getBreakpoint_1.getBreakpoint(1)(_templateObject3));
	});
	var Wrapper = styled_components_1.default.a(_templateObject4, LINK_CSS);
	var GatsbyLinkWrapper = styled_components_1.default(gatsby_link_1.default)(_templateObject4, LINK_CSS);
	exports.default = exports.Link;

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _taggedTemplateLiteralLoose2 = __webpack_require__(3);
	
	var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(["\n  fill: ", ";\n"], ["\n  fill: ", ";\n"]);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var polished_1 = __webpack_require__(8);
	// @ts-ignore
	var theme = __webpack_require__(7);
	exports.Logotype = function (props) {
	    return React.createElement(Wrapper, (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 460.94 131.32" }, props), React.createElement("path", { d: "M451.7,70.5c-2.87,4.14-6.25,7.87-11,9.81a5.14,5.14,0,0,1-1.1.31v0l.15,0-.15,0a52.74,52.74,0,0,0-4.16-14c-1.21-2.65-7.35-6.72-8.93-2-2.49,7.49-3.33,17.76,3.76,23-.35,4.17-2.5,7.93-4.6,11.5-3.43,5.85-7.92,10.79-14.14,13.67-3.7,1.71-9.16,3.56-12.22-.2-6-7.38-2.82-21.11,0-29.18a56.71,56.71,0,0,1,4.72-10.15c5.06-8.43,12.95-14.92,23.25-13.9,6.72.66,4.49-8.76-.91-9.6-28.1-4.38-43,23.71-58.07,42.38-6.4,7.93-13,15.84-22,20.79l-.12.06a15.61,15.61,0,0,1-1.26-4.46c-.64-5.18.28-10.52,1.38-15.57a129,129,0,0,1,8.17-24.81c2.22-5-5.84-10.85-8.79-5.53a200.13,200.13,0,0,1-14.65,22.56,115,115,0,0,1-14.77,16.7c-3.75,3.37-8.88,7.7-14.23,7.78a6.64,6.64,0,0,1-2.55-.42c-.32-.12-1.4-.81-1.58-.9a9.27,9.27,0,0,1-2.43-3.79A29.8,29.8,0,0,1,294,99.29c1.38-2,2.71-4,4-5.94,2.28-3.49,4.3-7.21,6.34-10.85,8.2-14.62,15.87-29.85,20.78-45.93,3.36-11,7.11-30.55-7.22-35.83-11.69-4.31-19,11.25-22.48,19.64A168.3,168.3,0,0,0,284.11,67a24.63,24.63,0,0,0-15.21.2C260,70.06,252.45,76.93,248,85.24a2.3,2.3,0,0,0-.23.41l-.1.2c-.52,1-1,2-1.44,3.08-4.16,8.82-9.71,19.48-18.51,23.63a10.11,10.11,0,0,1-5.42,1c-.91-.15,0,.23-1.15-.39-.13-.31-.31-.7-.51-1.09a17.42,17.42,0,0,1-1.84-7.08c-.32-5.23,1-10.5,2.66-15.4a78.42,78.42,0,0,1,8.43-17.29c2.37-3.61-5.6-10.21-8.47-5.86a86.34,86.34,0,0,0-4.47,7.62l-.39-.46c-6.74-7.62-16.68-10.56-25.9-5.42-5.79,3.23-10.12,8-14.33,12.94a2.92,2.92,0,0,0-1,1c-.17.25-.33.51-.49.76-.93,1.1-1.86,2.2-2.81,3.28-6.35,7.24-13.41,13.9-20.42,20.5-5.1,4.79-10.4,10.63-17.72,11.47-6.56.76-12.41-1.17-14.25-7.77s-.91-13.1,1.38-19.21l.62-1.37c11,1.09,29.55,1.37,33.25-10.5C158.1,68.89,147,59,137.16,60.15c-8.42,1-14.68,7.42-19,14.23a55.25,55.25,0,0,0-4.27,8.09c-3.54,7.55-6.52,15.77-12.3,21.93A66.21,66.21,0,0,1,76.08,121c-2.65,1-7.53,2.49-10,1.39.38.11-.31-.83-.47-1.86a18.87,18.87,0,0,1,.09-5.09c.81-7.24,3.74-14.56,7.31-20.9C77.37,88,81.42,81.15,85.35,74.26l21.16-.68c4.55-.15-1.56-8.25-4.68-8.15l-11.67.38,2-3.59c7.39-12.87,16.31-28,16.59-43.26a6.35,6.35,0,0,0-4.07-6.09c-1.94-.73-5.13-.13-5.18,2.52-.22,12-6.44,23.68-12,34-3.07,5.71-6.4,11.26-9.76,16.8l-15.24.49c-4.55.14,1.56,8.24,4.68,8.14l5.44-.18c-1.29,2.15-2.57,4.3-3.82,6.48a96,96,0,0,1-31.34,33.23c-1.39.89-2.84,1.76-4.35,2.59,2.45-6.8,1.53-14.84-.65-21.52C29.67,86.83,23,79.09,31,71.16a26.16,26.16,0,0,1,7.62-5c1.1-.5,2.22-.91,3.35-1.34.48-.19,2.38-.7.55-.21C48.46,63,43.83,54,39,55.35,27.36,58.48,15.71,67.53,17.83,80.88c.84,5.32,3.87,9.6,5.66,14.56a26.78,26.78,0,0,1,1.45,13.78c-1.93,10.62-11.27,11.65-20,8.19-5.19-2-6.2,4-3.37,7.12,8.59,9.36,23.86,7.38,34.12,2.64A88.69,88.69,0,0,0,56.6,113.25c-.17,5.61,1.29,10.83,5.59,14.58,7.37,6.43,17.68,2.89,25.47-.83A72,72,0,0,0,109,111.83c.75-.81,1.46-1.65,2.14-2.51a25.23,25.23,0,0,0,6.18,10.48c8.27,8.46,22.69,9.64,32.19,2.61A161.06,161.06,0,0,0,169,104.79a19.87,19.87,0,0,0,3.7,8.87c7.38,10,19.87,11.14,29.57,3.83a36.92,36.92,0,0,0,8.68-9.41c.24.85.52,1.7.85,2.54,3.72,9.57,13.25,15.19,22.94,9.8a34.53,34.53,0,0,0,10.07-8.9,16.84,16.84,0,0,0,1.41,2.86,20.11,20.11,0,0,0,28.66,6,65.39,65.39,0,0,0,12.55-12.2,26.13,26.13,0,0,0,2.44,3.94c10.32,13.67,26.45,4.54,36-4.74a122.68,122.68,0,0,0,9.74-10.73c-1.14,8.11-.82,16.86,4.55,22.59,7.3,7.79,17.07.09,22.89-5.45,9-8.58,16.55-18.79,23.93-28.78.77-1,1.54-2.06,2.31-3.09-3.51,11.75-4.81,27.41,4.06,36.94,10.79,11.58,28.48,2.74,36.63-7.54,4.18-5.29,8.76-12.28,9.78-19.08q.12-.84.21-1.68c8.32-.47,16-8,20.57-14.55C463.63,71.52,455.13,65.57,451.7,70.5ZM7.82,119.44l-.32-.22-.09-.06L7.28,119C7.47,119.08,8,119.38,7.82,119.44ZM139,69.48c2-.67,5.71-1.5,7.21.52,1.72,2.32-.54,5.75-2.32,7.18-4.36,3.49-11,3.9-16.39,4.07-.51,0-1,0-1.54,0C129,76.28,133.3,71.36,139,69.48Zm53,42.4c-4.91,2.55-11.81,3-14.1-3.08-2.5-6.59,2.35-15.34,5.87-20.79a.2.2,0,0,0,0-.08c6.28-7.64,14.06-15.61,22.68-13.47,3.35.83,5.48,3.44,6.81,5.88C208.17,91.75,203.69,105.79,191.94,111.88Zm29.26,1.49c0-.06,0-.12-.08-.19C221.28,113.3,221.29,113.39,221.2,113.37Zm63-36.45,0,0a2.2,2.2,0,0,1-.49-.36ZM298,45.46c2.64-10.83,5.94-24.24,13.56-32.8a11,11,0,0,1,3.28-2.75,2.16,2.16,0,0,1,.82-.26,2,2,0,0,1,.48.09A3.8,3.8,0,0,1,318,12.37a18.48,18.48,0,0,1,.55,6.78c-.94,13.72-7.52,27.32-13.42,39.49-3.81,7.84-7.89,15.61-12.32,23.14A168.27,168.27,0,0,1,298,45.46Zm-25.76,63.47c-3.65,3.55-8.21,7-13.59,5.11-5-1.75-5.91-6.23-5.5-11a30.39,30.39,0,0,1,8.78-19.3c4.41-4.65,10.93-8.81,17.64-8.34a15.6,15.6,0,0,1,3.6.85l.17.08a94.18,94.18,0,0,0,.34,19.4A112.48,112.48,0,0,1,272.23,108.93Zm74,4.09c-.83.38-.46-.42,0,0Zm8.2-72.3c-.21-1.72.73-3.4,1.54-4.86a25.69,25.69,0,0,1,4.93-6,15.77,15.77,0,0,1,2.77-2.12,8.57,8.57,0,0,1,2.48-1.27,1.85,1.85,0,0,1,1.78,0,1.06,1.06,0,0,1,.92,1.08c.1.76.19,1.51.29,2.27.21,1.73-.73,3.41-1.54,4.86a25.09,25.09,0,0,1-4.94,6,15,15,0,0,1-2.76,2.13,8.82,8.82,0,0,1-2.48,1.27,1.87,1.87,0,0,1-1.78,0A1.09,1.09,0,0,1,354.7,43C354.61,42.24,354.52,41.48,354.42,40.72Z" }));
	};
	var colors = {
	    logotype: theme('mode', {
	        light: function light(props) {
	            return props.theme.color.black;
	        },
	        dark: function dark(props) {
	            return polished_1.lighten(1, props.theme.color.black);
	        }
	    })
	};
	var Wrapper = styled_components_1.default.svg(_templateObject, colors.logotype);

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(10);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	function NoBackgroundScroll(Component) {
	    return function (_React$Component) {
	        (0, _inherits3.default)(_class, _React$Component);
	
	        function _class() {
	            (0, _classCallCheck3.default)(this, _class);
	            return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	        }
	
	        _class.prototype.componentDidMount = function componentDidMount() {
	            var body = document.querySelector('body');
	            body.style.overflow = 'hidden';
	        };
	
	        _class.prototype.componentWillUnmount = function componentWillUnmount() {
	            var body = document.querySelector('body');
	            body.style.overflow = '';
	        };
	
	        _class.prototype.render = function render() {
	            return React.createElement(Component, (0, _extends3.default)({}, this.props));
	        };
	
	        return _class;
	    }(React.Component);
	}
	exports.NoBackgroundScroll = NoBackgroundScroll;

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _taggedTemplateLiteralLoose2 = __webpack_require__(3);
	
	var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
	
	var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(["\n  animation: ", " 100ms ease-in-out;\n  background-color: ", ";\n  bottom: 0;\n  left: 0;\n  height: 100%;\n  overflow-y: auto;\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 100%;\n"], ["\n  animation: ", " 100ms ease-in-out;\n  background-color: ", ";\n  bottom: 0;\n  left: 0;\n  height: 100%;\n  overflow-y: auto;\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 100%;\n"]);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var styled_components_1 = __webpack_require__(2);
	var keyframes_1 = __webpack_require__(38);
	var polished_1 = __webpack_require__(8);
	// @ts-ignore
	var theme = __webpack_require__(7);
	var colors = {
	    background: theme('mode', {
	        light: function light(props) {
	            return polished_1.transparentize(0.25, polished_1.invert(props.theme.color.black));
	        },
	        dark: function dark(props) {
	            return polished_1.transparentize(0.25, props.theme.color.black);
	        }
	    })
	};
	exports.Overlay = styled_components_1.default.aside(_templateObject, keyframes_1.fadeIn, colors.background);

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck2 = __webpack_require__(10);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	
	var Root = function (_React$Component) {
	    (0, _inherits3.default)(Root, _React$Component);
	
	    function Root() {
	        (0, _classCallCheck3.default)(this, Root);
	        return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	    }
	
	    Root.prototype.componentDidMount = function componentDidMount() {
	        // @ts-ignore
	        var backgroundColor = this.props.theme.backgroundColor[this.props.theme.mode];
	        // @ts-ignore
	        var textColor = this.props.theme.textColor[this.props.theme.mode];
	        document.body.style.backgroundColor = backgroundColor;
	        document.body.style.color = textColor;
	    };
	
	    Root.prototype.render = function render() {
	        return React.createElement("div", null, this.props.children);
	    };
	
	    return Root;
	}(React.Component);
	
	exports.default = styled_components_1.withTheme(Root);

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _taggedTemplateLiteralLoose2 = __webpack_require__(3);
	
	var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
	
	var _classCallCheck2 = __webpack_require__(10);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty = __webpack_require__(76);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _getOwnPropertyDescriptor = __webpack_require__(77);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _templateObject = (0, _taggedTemplateLiteralLoose3.default)([""], [""]),
	    _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(["\n  background-color: ", ";\n  border-width: 1px;\n  border-style: solid;\n  border-color: ", ";\n  box-sizing: border-box;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  ", ";\n"], ["\n  background-color: ", ";\n  border-width: 1px;\n  border-style: solid;\n  border-color: ", ";\n  box-sizing: border-box;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  ", ";\n"]),
	    _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(["\n\t\tborder-radius: 2px; \n\t\twidth: auto;\n\t\theight: auto; \n\t\tbottom: auto;\n\t\tright: auto; \n\t"], ["\n\t\tborder-radius: 2px; \n\t\twidth: auto;\n\t\theight: auto; \n\t\tbottom: auto;\n\t\tright: auto; \n\t"]),
	    _templateObject4 = (0, _taggedTemplateLiteralLoose3.default)(["\n  align-items: center;\n  box-sizing: border-box;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  width: 100%;\n  ", ";\n  ", ";\n"], ["\n  align-items: center;\n  box-sizing: border-box;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  width: 100%;\n  ", ";\n  ", ";\n"]),
	    _templateObject5 = (0, _taggedTemplateLiteralLoose3.default)(["\n\t\tdisplay: none;\n\t"], ["\n\t\tdisplay: none;\n\t"]),
	    _templateObject6 = (0, _taggedTemplateLiteralLoose3.default)(["\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  line-height: 0;\n  margin: 0;\n  padding: 0;\n"], ["\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  line-height: 0;\n  margin: 0;\n  padding: 0;\n"]),
	    _templateObject7 = (0, _taggedTemplateLiteralLoose3.default)(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"]),
	    _templateObject8 = (0, _taggedTemplateLiteralLoose3.default)(["\n\t\t", ";\n\t\t", ";\n\t\tborder-bottom: 1px solid ", ";\n\t"], ["\n\t\t", ";\n\t\t", ";\n\t\tborder-bottom: 1px solid ", ";\n\t"]),
	    _templateObject9 = (0, _taggedTemplateLiteralLoose3.default)(["\n  margin: 0;\n  padding: 0;\n  animation: ", " 300ms ease-out forwards;\n  transform-origin: 0 0;\n"], ["\n  margin: 0;\n  padding: 0;\n  animation: ", " 300ms ease-out forwards;\n  transform-origin: 0 0;\n"]),
	    _templateObject10 = (0, _taggedTemplateLiteralLoose3.default)(["\n  opacity: 0;\n  animation: ", " 300ms ease-out forwards;\n  ", " position: relative;\n  list-style-type: none;\n"], ["\n  opacity: 0;\n  animation: ", " 300ms ease-out forwards;\n  ", " position: relative;\n  list-style-type: none;\n"]),
	    _templateObject11 = (0, _taggedTemplateLiteralLoose3.default)(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: opacity 150ms ease-in-out;\n  ", ";\n  ", ";\n  ", " &:hover {\n    opacity: 0.65;\n  }\n"], ["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: opacity 150ms ease-in-out;\n  ", ";\n  ", ";\n  ", " &:hover {\n    opacity: 0.65;\n  }\n"]),
	    _templateObject12 = (0, _taggedTemplateLiteralLoose3.default)(["\n\t\t", ";\n\t"], ["\n\t\t", ";\n\t"]),
	    _templateObject13 = (0, _taggedTemplateLiteralLoose3.default)(["\n  opacity: 0.65;\n  ", ";\n"], ["\n  opacity: 0.65;\n  ", ";\n"]);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
	    var c = arguments.length,
	        r = c < 3 ? target : desc === null ? desc = (0, _getOwnPropertyDescriptor2.default)(target, key) : desc,
	        d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    }return c > 3 && r && (0, _defineProperty2.default)(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var constants_1 = __webpack_require__(6);
	var calcFontScale_1 = __webpack_require__(28);
	var getBreakpoint_1 = __webpack_require__(17);
	var isBreakpoint_1 = __webpack_require__(73);
	var generateDelay_1 = __webpack_require__(72);
	var keyframes_1 = __webpack_require__(38);
	// @ts-ignore
	var theme = __webpack_require__(7);
	var Icon_1 = __webpack_require__(16);
	var Overlay_1 = __webpack_require__(68);
	var NoBackgroundScroll_1 = __webpack_require__(67);
	var SelectMenu = function (_React$Component) {
	    (0, _inherits3.default)(SelectMenu, _React$Component);
	
	    function SelectMenu(props) {
	        (0, _classCallCheck3.default)(this, SelectMenu);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	        _this.calcOffsetTop = function () {
	            var button = _this.props.parentElem;
	            var menu = _this.element;
	            if (menu) {
	                var buttonOffsetTop = button.getBoundingClientRect().top;
	                var buttonOffsetBottom = buttonOffsetTop + button.clientHeight;
	                var availableSpace = window.innerHeight - buttonOffsetBottom;
	                if (availableSpace >= menu.clientHeight) {
	                    return buttonOffsetBottom + 8;
	                }
	                return buttonOffsetTop - menu.clientHeight - 8;
	            }
	        };
	        _this.calcOffsetLeft = function () {
	            var button = _this.props.parentElem;
	            var menu = _this.element;
	            if (menu) {
	                var buttonOffsetLeft = button.getBoundingClientRect().left;
	                var availableSpace = window.innerWidth - buttonOffsetLeft;
	                if (availableSpace >= menu.clientWidth) {
	                    return buttonOffsetLeft;
	                }
	                return buttonOffsetLeft - (menu.clientWidth - button.clientWidth);
	            }
	        };
	        _this.calcPosition = function () {
	            if (isBreakpoint_1.isBreakpoint(1)) {
	                var _this$state = _this.state,
	                    offsetTop = _this$state.offsetTop,
	                    offsetLeft = _this$state.offsetLeft;
	
	                return {
	                    top: offsetTop + "px",
	                    left: offsetLeft + "px"
	                };
	            }
	        };
	        _this.handleClick = function (event) {
	            if (_this.element && !_this.element.contains(event.target)) {
	                _this.props.onClose();
	            }
	        };
	        _this.updatePosition = _this.updatePosition.bind(_this);
	        _this.state = { offsetTop: 0, offsetLeft: 0 };
	        return _this;
	    }
	
	    SelectMenu.prototype.componentDidMount = function componentDidMount() {
	        this.updatePosition();
	        window.addEventListener('resize', this.updatePosition);
	        document.addEventListener('click', this.handleClick, false);
	    };
	
	    SelectMenu.prototype.componentWillUnmount = function componentWillUnmount() {
	        window.removeEventListener('resize', this.updatePosition);
	        document.removeEventListener('click', this.handleClick, false);
	    };
	
	    SelectMenu.prototype.updatePosition = function updatePosition() {
	        this.setState({
	            offsetTop: this.calcOffsetTop(),
	            offsetLeft: this.calcOffsetLeft()
	        });
	    };
	
	    SelectMenu.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            title = _props.title,
	            options = _props.options,
	            onClose = _props.onClose,
	            onChange = _props.onChange,
	            selected = _props.selected;
	
	        return React.createElement(Wrapper, null, React.createElement(Overlay_1.Overlay, null), React.createElement(Inner, { innerRef: function innerRef(element) {
	                return _this2.element = element;
	            }, role: "menu", style: this.calcPosition() }, React.createElement(Header, null, React.createElement(CloseButton, { onClick: onClose }, React.createElement(Icon_1.Icon, { icon: "cancel", size: 20 }))), title && React.createElement(Title, null, title), React.createElement(Items, null, options.map(function (option) {
	            return React.createElement(Item, { role: "menuitem", key: option.value }, React.createElement(ItemLink, { role: "option", onClick: function onClick() {
	                    onChange(option);
	                } }, option.label, selected.value === option.value && React.createElement(CheckIcon, { size: 20, icon: "verified" })));
	        }))));
	    };
	
	    return SelectMenu;
	}(React.Component);
	SelectMenu = __decorate([NoBackgroundScroll_1.NoBackgroundScroll], SelectMenu);
	exports.SelectMenu = SelectMenu;
	var colors = {
	    background: theme('mode', {
	        light: 'white',
	        dark: 'rgb(20, 20, 20)'
	    }),
	    border: theme('mode', {
	        light: '#ddd',
	        dark: 'rgb(47, 47, 47)'
	    })
	};
	var Wrapper = styled_components_1.default.aside(_templateObject);
	var Inner = styled_components_1.default.div(_templateObject2, colors.background, colors.border, getBreakpoint_1.getBreakpoint(1)(_templateObject3));
	var Header = styled_components_1.default.header(_templateObject4, colors.border, constants_1.SPACE.inset.s, getBreakpoint_1.getBreakpoint(1)(_templateObject5));
	var CloseButton = styled_components_1.default.button(_templateObject6);
	var Title = styled_components_1.default.h2(_templateObject7, calcFontScale_1.calcFontScale(1), constants_1.SPACE.inset.s, getBreakpoint_1.getBreakpoint(1)(_templateObject8, calcFontScale_1.calcFontScale(0.25), constants_1.SPACE.inset.squish.s, colors.border));
	var Items = styled_components_1.default.ul(_templateObject9, keyframes_1.unfurl);
	var Item = styled_components_1.default.li(_templateObject10, keyframes_1.fadeIn, generateDelay_1.generateDelay('&', 3, 0.3));
	var ItemLink = styled_components_1.default.a(_templateObject11, calcFontScale_1.calcFontScale(0), constants_1.SPACE.inset.s, getBreakpoint_1.getBreakpoint(1)(_templateObject12, constants_1.SPACE.inset.squish.s));
	var CheckIcon = styled_components_1.default(Icon_1.Icon)(_templateObject13, constants_1.SPACE.inline.xs);

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _taggedTemplateLiteralLoose2 = __webpack_require__(3);
	
	var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
	
	var _classCallCheck2 = __webpack_require__(10);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(["\n  position: relative;\n  display: inline-block;\n"], ["\n  position: relative;\n  display: inline-block;\n"]),
	    _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(["\n  align-items: center;\n  display: flex;\n  margin: 0;\n  &:hover {\n    top: 0;\n  }\n\n  svg {\n    transition: all 150ms ease-in-out;\n    ", ";\n  }\n\n  &:focus,\n  &:active {\n    top: 0;\n    svg {\n      transform: rotate(180deg);\n    }\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  margin: 0;\n  &:hover {\n    top: 0;\n  }\n\n  svg {\n    transition: all 150ms ease-in-out;\n    ", ";\n  }\n\n  &:focus,\n  &:active {\n    top: 0;\n    svg {\n      transform: rotate(180deg);\n    }\n  }\n"]);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var constants_1 = __webpack_require__(6);
	var SelectMenu_1 = __webpack_require__(70);
	var Button_1 = __webpack_require__(46);
	var Icon_1 = __webpack_require__(16);
	
	var Select = function (_React$Component) {
	    (0, _inherits3.default)(Select, _React$Component);
	
	    function Select(props) {
	        (0, _classCallCheck3.default)(this, Select);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	        _this.handleOpen = function () {
	            _this.setState({ isVisible: true });
	        };
	        _this.handleClose = function () {
	            _this.setState({ isVisible: false });
	        };
	        /* Todo: any */
	        _this.handleChange = function (option) {
	            _this.setState({ selected: option });
	            _this.props.onChange(option);
	            _this.handleClose();
	        };
	        _this.state = {
	            isVisible: false,
	            selected: props.options.find(function (obj) {
	                return obj.value === props.value;
	            })
	        };
	        return _this;
	    }
	
	    Select.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (nextProps.value !== this.props.value) {
	            this.setState({
	                selected: this.props.options.find(function (obj) {
	                    return obj.value === nextProps.value;
	                })
	            });
	        }
	    };
	
	    Select.prototype.render = function render() {
	        var _this2 = this;
	
	        var _state = this.state,
	            selected = _state.selected,
	            isVisible = _state.isVisible;
	        var _props = this.props,
	            title = _props.title,
	            options = _props.options;
	
	        return React.createElement(Wrapper, { innerRef: function innerRef(element) {
	                return _this2.element = element;
	            } }, selected && React.createElement(SelectButton, { size: "micro", onClick: this.handleOpen, role: "button", "aria-haspopup": "true" }, selected.label, " ", React.createElement(Icon_1.Icon, { size: 13, icon: "caron" })), isVisible && React.createElement(SelectMenu_1.SelectMenu, { options: options, onClose: this.handleClose, onChange: this.handleChange, parentElem: this.element, title: title, selected: selected }));
	    };
	
	    return Select;
	}(React.Component);
	
	exports.Select = Select;
	var Wrapper = styled_components_1.default.div(_templateObject);
	var SelectButton = styled_components_1.default(Button_1.Button)(_templateObject2, constants_1.SPACE.inline.xs);

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var localeData = __webpack_require__(595);
	var messages = __webpack_require__(501);
	var react_intl_1 = __webpack_require__(12);
	var Layout_1 = __webpack_require__(75);
	react_intl_1.addLocaleData(localeData);
	var enLayout = function enLayout(props) {
	  return React.createElement(Layout_1.default, (0, _extends3.default)({}, props, { locale: "en", messages: messages }));
	};
	exports.default = enLayout;

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.generateDelay = function (selector, size, second) {
	    return Array.apply(undefined, { length: size }).map(Number.call, Number).map(function (i) {
	        if (i > 0) {
	            return template(selector, i, second * (i / (size - 1)));
	        }
	    }).join('');
	};
	var template = function template(selector, index, second) {
	    return selector + ":nth-child(" + (index + 1) + ") {\n\t\tanimation-delay: " + second + "s;\n\t}";
	};

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(6);
	exports.isBreakpoint = function (index) {
	  return window.innerWidth >= parseInt(constants_1.BREAKPOINTS[index], 10);
	};

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _taggedTemplateLiteralLoose2 = __webpack_require__(3);
	
	var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
	
	var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(["\n\t0% {\n\t\ttransform: scale(0);\n\t}\n\t100% {\n\t\ttransform: scale(1);\n\t}\n"], ["\n\t0% {\n\t\ttransform: scale(0);\n\t}\n\t100% {\n\t\ttransform: scale(1);\n\t}\n"]),
	    _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(["\n\t0% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n"], ["\n\t0% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n"]);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var styled_components_1 = __webpack_require__(2);
	exports.unfurl = styled_components_1.keyframes(_templateObject);
	exports.fadeIn = styled_components_1.keyframes(_templateObject2);

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var react_helmet_1 = __webpack_require__(105);
	var Root_1 = __webpack_require__(69);
	var Header_1 = __webpack_require__(64);
	var Footer_1 = __webpack_require__(63);
	var theme_1 = __webpack_require__(74);
	__webpack_require__(96);
	__webpack_require__(97);
	var react_intl_1 = __webpack_require__(12);
	var LayoutTemplate = function LayoutTemplate(_ref) {
	    var locale = _ref.locale,
	        messages = _ref.messages,
	        children = _ref.children;
	
	    return React.createElement(react_intl_1.IntlProvider, { locale: locale, key: locale, messages: messages, textComponent: React.Fragment }, React.createElement(styled_components_1.ThemeProvider, { theme: (0, _extends3.default)({ mode: 'light' }, theme_1.default) }, React.createElement(Root_1.default, null, React.createElement(react_helmet_1.default, { htmlAttributes: { lang: locale } }, React.createElement("title", null, "Steadio \u2014 Sign in \u2014 Tumblbug")), React.createElement(Header_1.default, { isDumb: true }), React.createElement("main", null, children()), React.createElement(Footer_1.default, null))));
	};
	exports.default = LayoutTemplate;

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

	module.exports = {"footer.terms_of_use":"Terms of Use","footer.privacy_policy":"Privacy Policy","footer.select_your_language":"Select Your Language","forgot_password.email":"Email","forgot_password.email_placeholder":"Enter your email","forgot_password.submit":"Continue","header.sign_in":"Sign in","reset_password.confirmation_code":"Confirmation Code","reset_password.confirmation_code_placeholder":"6-digit number","reset_password.password":"New password","reset_password.password_placeholder":"Enter your new password","reset_password.submit":"Reset password","sign_in.email":"Email","sign_in.email_placeholder":"Enter your email","sign_in.password":"Password","sign_in.password_placeholder":"Enter your password","sign_in.forgot_password":"Forgot password?","sign_in.submit":"Sign in","sign_in.no_account":"Not a member yet?","sign_in.sign_up":"Sign up","sign_up.fullname":"Fullname","sign_up.fullname_placeholder":"Enter your fullname","sign_up.email":"Email","sign_up.email_placeholder":"Enter your email","sign_up.password":"Password","sign_up.password_placeholder":"Enter your password","sign_up.opt_in":"Receive our weekly newsletter and other occasional updates","sign_up.submit":"Sign up","sign_in.header_title":"Login with Tumblbug account","sign_in.header_body":"Tumblbug user can Login Steadio with the same email and password.","sign_in.login_failed":"Login failed","sign_in.user_not_found":"There is no account signed up with this email","sign_in.authentication_failed":"The password is incorrect","forgot_password.header_title":"Password assistance","forgot_password.header_body":"Enter the email address associated with your Tumblbug account.","reset_password.header_title":"Verifying it's you","reset_password.header_body":"For your security, we need to verify your identity. We've sent a code to your email. Please enter it below.","sign_up.header_title":"Create a new Tumblbug account","sign_up.header_body":"Tumblbug user can Login Steadio with the same email and password.","sign_up.hasAccount":"Have a Tumblbug account?"}

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-en-tsx-2e4df65181867d508523.js